import { Injectable } from "@angular/core";
import { ToasterService } from "angular2-toaster";


@Injectable()
export class ErrorMessageService {

    constructor(private toaster: ToasterService) {

    }

    getProfesseurDeleteMessage(data) {
        let message = null;
        switch(data) {
            case -2:
                message = 'Il y a encore des cours pour ce professeur';
                break;
            default:
                message = 'Problème technique';
                break;
        }
        return message;
    }

    showEleveDeleteMessage(data) {

        switch (data) {
            case -2:
                this.toaster.pop('error', 'Il reste des inscriptions');
                break;
            case -1:
                this.toaster.pop('error', 'Problème technique');
                break;
            default:
                this.toaster.pop('error', 'Erreur lors de la suppression de l\'élève');
                break;
        }
    }

    getCoursCreateMessage(data) {
        let message = null;
        switch (data) {
            default:
            case -1:
                message = 'Problème technique';
                break;
            case -2:
                message = 'Le professeur n\'est pas disponible';
                break;
            case -4:
                message = 'La discipline n\'est pas renseignée';
                break;
            case -5:
                message = 'La salle est déjà utilisée.';
                break;
            case -6:
                message = 'Le professeur et la salle ne sont pas disponibles';
                break;
            case -7:
                message = 'La salle n\'est pas disponible pour les heures du cours';
                break;
        }
        return message;
    }


    getFamilleDeleteMessage(data) {
        let message = null;
        switch (data) {
            case -2:
                message = 'Il y a encore des élèves dans la famille';
                break;

            case -3:
                message = 'Il y a encore des factures validées pour la famille';
                break;

            case -4:
                message = 'Il y a encore des paiements pour la famille';
                break;

            case -5:
                message = 'Il y a encore des prets/locations pour la famille';
                break;

            case -1:
                message = 'Problème technique';
                break;

            default:
                break;
        }
        return message;
    }


}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/services/error-message.service.ts